import React, { useCallback } from 'react';
import {
    Create,
    DateInput,
    SimpleForm,
    Toolbar,
} from 'react-admin';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import { useFormContext } from 'react-hook-form';

const buttonIcon = <LibraryBooksIcon />;

const GenerateReportButton = ({
    icon = buttonIcon,
    label = 'ra.action.create',
    ...props
    }) => {

    const form = useFormContext();

    const generateReport = useCallback(() => {
        var formdata = form.getValues();
        console.log('generateReport formdata:', formdata);
        fetch( `/api/reports`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formdata) })
            .then(response => response.blob())
            .then(blob => {
                console.log('blob:', blob);
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = formdata.Start_Date + "-to-" + formdata.End_Date + "-billing-report.pdf";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch((e) => {
                console.log('exception:',e);
            });
    }, [form]);

    return (
        <Button
            onClick={generateReport}
            {...props}
        >
        {icon} &nbsp;Generate Report
        </Button>
    );
};

const ReportCreateToolbar = props => (
    <Toolbar {...props}>
        <Box display="flex" justifyContent="space-between" width="100%">
            <GenerateReportButton
                color="primary"
            />
        </Box>
    </Toolbar>
);

const ReportCreateForm = props => (
    <SimpleForm
        {...props}
        toolbar={<ReportCreateToolbar />}
    >
        <Box p="1em">
            <DateInput source="Start_Date" />
        </Box>
        <Box p="1em">
            <DateInput source="End_Date" />
        </Box>
    </SimpleForm>
);

export const ReportCreate = props => (
    <Create {...props}>
        <ReportCreateForm />
    </Create>
);
